import { render, staticRenderFns } from "./CarrierForm.vue?vue&type=template&id=4b12bfb4&"
import script from "./CarrierForm.vue?vue&type=script&lang=js&"
export * from "./CarrierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports